import { TableHeader } from "@/models/TableHeader";

export const reviewsApprovalHeaders: TableHeader[] = [
  {
    text: "Loc. Code",
    value: "facility.location_code"
  },
  {
    text: "Name",
    value: "last_name"
  },
  {
    text: "Email",
    value: "email"
  },
  {
    text: "Rating",
    value: "rating"
  },
  {
    text: "Created At",
    value: "created_at"
  },
  {
    text: "Denied",
    value: "judged"
  },
  {
    text: "Content",
    value: "content"
  },
  {
    text: "Actions...",
    value: null,
    sortable: false
  }
];
